/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import { Col, Container, Row, Form } from 'react-bootstrap';
import './settings.scss';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import ToastMessage from '../../common/ToastMessage';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import {
  HttpErrorCodes,
  HttpSuccessCodes,
} from '../../../errorhandling/HttpErrorCodes';
import { setReportConfig } from '../../../../redux/app/appSlice';
import { UpdateReportingConfig } from '../../../utils/common';
import Checkbox from '../../common/Checkbox';
import GenericButton from '../../common/button';
import RadioInput from '../../common/radio';
import moment from 'moment';
import useDate from 'src/Admin/utils/useDate';

export default function Settings(props) {
  const { reportConfig } = useSelector((state) => state.app) || {};
  const { formatDate } = useDate();
  const [updatedReportConfigs, setUpdatedReportConfigs] =
    useState(reportConfig);

  //const [ reportSettingExcel, setReportSettingExcel ] = useState( reportConfig?.fileFormat?.excel ? reportConfig?.fileFormat?.excel : false );
  //const [ excelCheck, setExcelCheck ] = useState( reportConfig?.fileFormat?.excel ? true : false );

  //const [ reportSettingPdf, setReportSettingPdf ] = useState( reportConfig?.fileFormat?.pdf ? reportConfig?.fileFormat?.pdf : false );
  //const [ pdfCheck, setPdfCheck ] = useState( reportConfig?.fileFormat?.pdf ? true : false );

  const [reportSettingSyncStatus, setReportSettingSyncStatus] = useState(false);

  const [lastSyncDate, setLastSyncDate] = useState(
    reportConfig?.lastSyncDate ? reportConfig?.lastSyncDate : [],
  );

  const [reportSettingExpiry, setReportSettingExpiry] = useState(
    reportConfig?.expiry ? reportConfig?.expiry : 30,
  );
  const [reportSettingEmailNotification, setReportSettingEmailNotification] =
    useState(reportConfig?.emailNotification === 'Yes' ? 'Yes' : 'No');

  const [expiryValueCheck, setExpiryValueCheck] = useState(
    reportConfig?.expiry ? true : false,
  );

  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    const initialSetup = {
      //fileFormat: (reportConfig?.fileFormat ? reportConfig?.fileFormat : {'excel' : false, 'pdf': true}),
      expiry: reportConfig?.expiry ? reportConfig.expiry : 30,
      emailNotification: reportConfig?.emailNotification
        ? reportConfig.emailNotification
        : 'Yes',
    };

    setUpdatedReportConfigs((current) => {
      //👇️ using spread syntax (...)
      return {
        ...current,
        ...initialSetup,
      };
    });
  }, []);

  const onChangeHandler = (selectedValue, field) => {
    const updatedValues = {};
    const updatedFormat = {};
    //if(field === "excel") {
    //updatedFormat.excel = selectedValue || false;
    //setReportSettingExcel( selectedValue );
    //} else if(field === "pdf") {
    //updatedFormat.pdf = selectedValue || false;
    //setReportSettingPdf( selectedValue );
    //} else
    if (field === 'expiry') {
      if (selectedValue == '') {
        setExpiryValueCheck(false);
      } else {
        const expiryValue = parseInt(selectedValue);
        if (expiryValue > 0 && expiryValue < 1000) {
          setExpiryValueCheck(true);
        } else {
          setExpiryValueCheck(false);
        }
      }
      updatedValues.expiry = selectedValue || false;
      setReportSettingExpiry(selectedValue);
    }
    if (field === 'email_notification') {
      updatedValues.emailNotification = selectedValue || 'No';
      setReportSettingEmailNotification(selectedValue);
    }
    if (field === 'sync' && selectedValue == true) {
      updatedValues.reportSettingSyncStatus = selectedValue || false;
      setReportSettingSyncStatus(selectedValue);
      updatedValues.lastSyncDate = [moment().format('YYYY-MM-DD')];
      setLastSyncDate([moment().format('YYYY-MM-DD')]);
      updateSycnReport();
      updatedValues.forSave = Math.floor(Math.random() * 1000);
    }

    setUpdatedReportConfigs((current) => {
      //👇️ using spread syntax (...)
      return {
        ...current,
        ...updatedValues,
        //fileFormat: {
        //...current.fileFormat,

        ////👇️ override value for nested country property
        //...updatedFormat,
        //},
      };
    });
  };

  const updateTimeAndDate = async () => {
    const saveJson = UpdateReportingConfig(updatedReportConfigs);
    console.log('updatedReportConfigs', updatedReportConfigs);
    return await axiosInstance.put(
      APIEndpoints.putUpdateConfiguration(),
      JSON.stringify(saveJson),
    );
  };

  const updateSycnReport = async () => {
    return await axiosInstance.get(APIEndpoints.syncReportConfigration());
  };

  const handleSubmit = async () => {
    try {
      const response = await updateTimeAndDate();
      if (HttpSuccessCodes.HTTP_SUCCESS_CODE_200 === response.status) {
        dispatch(setReportConfig(updatedReportConfigs));
      }
      toast.success(
        <ToastMessage
          type="success"
          subTitle={'Report Settings updated successfully!'}
        />,
      );
    } catch (error) {
      console.log(error);
      if (error.toString().includes('409')) {
        toast.warning(
          <ToastMessage
            type="warning"
            subTitle={
              'No changes were made! You need to make some changes and try again.'
            }
          />,
        );
      } else {
        toast.error(
          <ToastMessage
            type="error"
            subTitle={'Failed to update Report Settings!'}
          />,
        );
      }
    }
  };

  return (
    <div>
      <Container className="mtop30 activationCode settings">
        <h2 className="configure_report_title">
          {t('admin.reports_setting.configure_report_title')}
        </h2>
        <Form>
          <Row>
            <Col md={8} lg={8} sm={8}>
              {/*<p className="maintain_reportfield mb-2 pb-2">{t( 'admin.reports_setting.select_format' )}</p> */}

              <Form.Group controlId="formBasicSSN" className="mb-0">
                {/*<div className='d-flex mb-3 checkbox_excel_pdf'>
                  <Checkbox
                    inline
                    key="report-settings-excel-Key"
                    label="EXCEL"
                    className="d-none"
                    value={reportSettingExcel}
                    id="report-settings-excel"
                    name="report-settings-excel"
                    onChange={( e ) => {
                      setExcelCheck(!excelCheck);
                      if(!e.target.checked) {
                        onChangeHandler(false, "excel")
                      } else {
                        onChangeHandler(true, "excel")
                      }
                    }}
                    checked={excelCheck}
                  />

                  <Checkbox
                    inline
                    key="report-settings-pdf-Key"
                    label="PDF"
                    className="d-none"
                    value={reportSettingPdf}
                    id="report-settings-pdf"
                    name="report-settings-pdf"
                    onChange={( e ) => {
                      setPdfCheck(!pdfCheck);
                      if(!e.target.checked) {
                        onChangeHandler(false, "pdf")
                      } else {
                        onChangeHandler(true, "pdf")
                      }
                    }}
                    checked={pdfCheck}
                  />
                </div> */}

                <Row className="mb-4 input-filed">
                  <Col md={8} lg={8} sm={8}>
                    <p className="maintain_duration_period mb-1 pb-1">
                      {t('admin.reports_setting.report_expiry')}
                    </p>
                    <div className="d-flex">
                      <Form.Control
                        type="number"
                        onKeyDown={(e) =>
                          (e.keyCode === 69 || e.keyCode === 190) &&
                          e.preventDefault()
                        }
                        placeholder="30"
                        value={reportSettingExpiry}
                        onChange={(e) =>
                          onChangeHandler(e.target.value, 'expiry')
                        }
                      />
                      <span className="days_text pl-3 pt-3">
                        {t('admin.reports_setting.days')}
                      </span>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <span className="maintain_reportfield mb-4">
                      {t('admin.reports_setting.email_notification')}
                    </span>
                    <div className="report-setting-radio p-0 mt-3">
                      <Form.Group
                        className="mb-3"
                        controlId="formBasicCheckbox1"
                      >
                        <Form.Check className="report-setting-true">
                          <div className="d-flex">
                            <RadioInput
                              id="email_notification"
                              label="Yes"
                              name="email_notification"
                              value="Yes"
                              checked={'Yes' === reportSettingEmailNotification}
                              onChange={(e) =>
                                onChangeHandler(
                                  e.target.value,
                                  'email_notification',
                                )
                              }
                            />
                            <div className="ml-5">
                              <RadioInput
                                id="email_notification2"
                                label="No"
                                name="email_notification"
                                value="No"
                                checked={
                                  'No' === reportSettingEmailNotification
                                }
                                onChange={(e) =>
                                  onChangeHandler(
                                    e.target.value,
                                    'email_notification',
                                  )
                                }
                              />
                            </div>
                          </div>
                        </Form.Check>
                      </Form.Group>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p className="pt-2">
                      <Form.Group controlId="formBasicSSN" className="mb-4">
                        <Checkbox
                          inline
                          key="report-sync-Key"
                          label="Sync Custom Reports"
                          className="d-none"
                          value={reportSettingSyncStatus}
                          id="report-settings-pdf"
                          name="report-settings-pdf"
                          onChange={(e) => {
                            setReportSettingSyncStatus(
                              !reportSettingSyncStatus,
                            );
                            if (!e.target.checked) {
                              onChangeHandler(false, 'sync');
                            } else {
                              onChangeHandler(true, 'sync');
                            }
                          }}
                        />
                      </Form.Group>
                    </p>
                  </Col>
                </Row>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-4 input-filed">
            <Col md={8} lg={8} sm={8}>
              <p>Last Sync Date</p>
              <div className="">
                {lastSyncDate &&
                  lastSyncDate.length > 0 &&
                  lastSyncDate.map((item, index) => (
                    <p
                      className="maintain_duration_period mb-0 pb-0"
                      key={index}
                    >
                      {formatDate(item)}
                    </p>
                  ))}
              </div>
            </Col>
          </Row>
        </Form>
        <Row>
          <Col>
            <GenericButton
              onClick={handleSubmit}
              className="ml-1 border-0"
              //disabled={
              //!((excelCheck || pdfCheck) && (expiryValueCheck) && (reportSettingEmailNotification == 'Yes' || reportSettingEmailNotification == 'No'))
              //}
              disabled={
                !(
                  expiryValueCheck &&
                  (reportSettingEmailNotification == 'Yes' ||
                    reportSettingEmailNotification == 'No')
                )
              }
            >
              {t('admin.reports_setting.save')}
            </GenericButton>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
